import React from 'react';
import Icon from '../components/Icon';
import QLabel from '../components/QLabel';


export default class NoNetwork extends React.Component{

    render(){

        return(
            <section className="assignment-section not-available bg-black not-available content-wrapper">
                <div className="container mini-container">
                    <div className="text-center">
                        <div className="row text-center justify-content-center height-center align-items-center">
                            <div className="col-10">
                                <Icon image={this.props.img}/>
                                <h3><QLabel label="Whoops"/></h3>
                                <span><QLabel label="Connecting_msg"/></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        )
    }
}